import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreInfoDivsComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-info-divs/mapfre-info-divs.component';
import { PolicyErrorSvgComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/policy-error-svg/policy-error-svg.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, PolicyErrorSvgComponent, MapfreInfoDivsComponent, MapfreButtonComponent],
  selector: 'app-businesspolicy-detected',
  templateUrl: './businesspolicy-detected.component.html',
  styleUrls: ['./businesspolicy-detected.component.scss'],
})
export class BusinesspolicyDetectedComponent {
  
}
